import React from "react"
import Layout from "./components/layout"
import menuStyle from "./components/menu.module.scss"
import MediaQuery from "react-responsive"

const MenuPage = () => {
  return (
    <div>
      <Layout>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>SAVOURY CREPES</h1>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>FROMAGE</h4>
              <p>classic cheese crepe with monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$5.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>FARMER BROWN</h4>
              <p>bacon, egg, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>PARISIAN</h4>
              <p>ham, egg, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>FLORENTINE</h4>
              <p>spinach, tomato, pesto, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.35</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>ANDALUSIAN</h4>
              <p>spinach, tomato, avocado, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.35</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CHICKEN SALSA</h4>
              <p>grilled cicken, caramelized onion salsa, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.65</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CHICKEN LYON</h4>
              <p>grilled chicken, ham, tomato, and monterey jack</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.65</p>
              </div>
            </div>
          </div>
        </div>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>SWEET CREPES</h1>
          </div>
          <div className={menuStyle.menuSubtitle}>
            <strong>
              Choose:
              <em> traditional french style or crepe rolls made to go</em>
            </strong>

            <br />
            <strong>
              Included:
              <em>
                {" "}
                powdered sugar, whipped cream and choice of syrup: nutella,
                chocolate, or caramel
              </em>
            </strong>

            <br />
            <strong>
              Additonal: one scoop of gelato or sorbetto for $2.50
            </strong>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>CLASSIC</h4>
              <p>nutella, chocolate or caramel</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$5.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CINNAMON</h4>
              <p>cinnamon sugar and butter</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$5.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>LEMON</h4>
              <p>freshly squeezed lemon juice</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$5.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>STRAWBERRY</h4>
              <p>fresh strawberries</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>STRAWBERRY ROYALE</h4>
              <p>fresh strawberries and fresh bananas</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>BANANA FOSTER</h4>
              <p>fresh bananas, butter, and cinnamon sugar</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>BREAKFAST CRUNCH</h4>
              <p>granola, nutella, and fresh bananas</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.25</p>
              </div>
            </div>
          </div>
        </div>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>PANINIS</h1>
          </div>
          <div className={menuStyle.menuSubtitle}>
            <em>
              Please inform us if you have any food allergies or dietary
              restrictions
            </em>
          </div>
          <div className={menuStyle.gridTriple}>
            <div className={menuStyle.foodItem}>
              <h4>JUST CHEESE</h4>
              <p>grilled cheese panini, choice of cheese*</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$4.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>VEGETARIAN</h4>
              <p>spinach, tomatoes, red onions, pesto, and choice of cheese*</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.35</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CLUB MELT</h4>
              <p>
                ham, turkey, bacon, tomatoes, dijon mustard, and choice of
                cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.gridTriple}>
            <div className={menuStyle.foodItem}>
              <h4>HAM, EGG & CHEESE</h4>
              <p>ham, egg, mayo, mustard, and choice of cheese*</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.75</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>HAM & CHEESE</h4>
              <p>ham, mayo, mustard, and choice of cheese*</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.35</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>BACON, EGG & CHEESE</h4>
              <p>bacon, egg, mayo, mustard, and choice of cheese*</p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.75</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.gridTriple}>
            <div className={menuStyle.foodItem}>
              <h4>TUSCAN PESTO CHICKEN</h4>
              <p>
                grilled chicken, tomatoes, pesto, mayo, and choice of cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.45</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>SPICY BUFFALO CHICKEN</h4>
              <p>
                grilled chicken, red onions, buffalo sauce, ranch, and choice of
                cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.45</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>ITALIAN</h4>
              <p>
                salami, copicollo, proscuitto, tomatoes, spinach, red onions,
                red wine vinaigrette, and choice of cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.gridDouble}>
            <div className={menuStyle.foodItem}>
              <h4>CALIFORNIA TURKEY</h4>
              <p>
                turkey, avocado, fire roasted fuji apple, fig spread, and choice
                of cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CUBAN PANINO</h4>
              <p>
                cuban - style marinated pulled pork, hickory smoked bacon,
                pepperonicinis, honey mustard, and choice of cheese*
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.menuSubtitle}>
            <strong>
              Choice of cheese: monterey jack, provolone, or swiss
            </strong>
          </div>
        </div>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>WRAPS & SALADS</h1>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>CHICKEN CAESAR</h4>
              <p>
                grilled chicken, romaine lettuce, shaved parmesan, and caesar
                dressing
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.50</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CHICKEN SPINACH</h4>
              <p>
                grilled chicken, spinach, tomatoes, red onions, shaved parmesan,
                and balsamic vinaigrette dressing
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.50</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>BUFFALO CHICKEN</h4>
              <p>
                grilled chicken, romaine lettuce, ranch, monterey jack, and
                buffalo dressing
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.50</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>GREEK CHICKEN</h4>
              <p>
                grilled chicken, romaine lettuce, tomatoes, red onions, feta
                cheese, and greek dressing
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.50</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>PULLED PORK</h4>
              <p>
                smoked pulled pork, romaine lettuce, red onion, tomatoes,
                monterey jack, and BBQ sauce
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$7.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <h4>TUNA SALAD</h4>
              <p>
                tuna salad, romaine lettuce, tomatoes, red onions, shaved
                parmesan, balsamic or lemon vinaigrette
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>CHICKEN CAESAR SALAD</h4>
              <p>
                grilled chicken, romaine lettuce, croutons, shaved parmesan, and
                caesar dressing
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>COBB SALAD</h4>
              <p>
                grilled chicken, bacon, romaine lettuce, egg, sahved parmesan,
                tomatoes, balsamic or lemon vinaigrette
              </p>
              <div className={menuStyle.diamondContainer}>
                <div className={menuStyle.diamond}></div>
                <p className={menuStyle.pCenter}>$6.95</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.menuSubtitle}>
            <strong>Ask for the dressing tossed in or on the side</strong>
          </div>
        </div>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>BOBA TEA</h1>
          </div>
          <div className={menuStyle.menuSubtitle}>
            Choose Sweetness Level: 0% | 50% | 75% | 100%
          </div>
          <div className={menuStyle.gridTriple}>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h4>MILK TEA</h4>
                <strong>HOT OR ICED</strong>
                <br />
                <strong>MOLTO: 4.00 | GRANDE: 4.50</strong>
                <p>Black Milk Tea</p>
                <p>Green Milk Tea</p>
                <p>Taro Milk Tea</p>
                <p>Matcha Milk Tea</p>
                <p>Thai Tea</p>
                <p>Vietnamese Coffee</p>
                <p>Rose Hip Tea</p>
                <p>Honeydew Milk Tea</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h4>FRUIT TEA</h4>
                <strong>HOT OR ICED</strong>
                <br />
                <strong>BASE: Green Tea or Black Tea</strong>
                <br />
                <strong>MOLTO: 4.00 | GRANDE: 4.50</strong>
                <p>Mango</p>
                <p>Pomegranate</p>
                <p>Peach</p>
                <p>Passion Fruit</p>
                <p>Strawberry</p>
                <p>Raspberry</p>
                <p>Lychee</p>
                <p>Pineapple</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h4>SLUSH</h4>
                <strong>MOLTO: 4.25 | GRANDE: 4.95</strong>
                <p>
                  Ube <br />
                  <strong>
                    <em>
                      <span style={{ fontSize: ".7rem" }}>*Black Tea Base</span>
                    </em>
                  </strong>
                </p>
                <p>Coconut Black Tea</p>
                <p>
                  Brown Sugar Black Tea <br />
                  <strong>
                    <em>
                      <span style={{ fontSize: ".7rem" }}>*Green Tea Base</span>
                    </em>
                  </strong>
                </p>
                <p>Honey Green Tea</p>
                <p>Matcha Green Tea</p>
              </div>
            </div>
          </div>
          <div className={menuStyle.menuTitle}>
            <h4>TOPPINGS</h4>
          </div>
          <div className={menuStyle.foodContainer}>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h6>BOBA</h6>
                <strong>50</strong>
                <p>Black Boba</p>
                <p>White Boba</p>
                <p>Crystal Boba</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h6>JELLIES</h6>
                <strong>50</strong>
                <p>Mango Star</p>
                <p>Rainbow</p>
                <p>Lychee Coconut</p>
                <p>Coffee</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h6>POPPIN' BOBA</h6>
                <strong>50</strong>
                <p>Pomegranate</p>
                <p>Mango</p>
                <p>Lychee</p>
                <p>Rainbow</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinkFlavor}>
                <h6>CREAMS</h6>
                <strong>75</strong>
                <p>Sea Salt Cream</p>
              </div>
            </div>
          </div>
        </div>
        <div className={menuStyle.menuContainer}>
          <div className={menuStyle.menuTitle}>
            <h1>BEVERAGES</h1>
          </div>
          <div className={menuStyle.menuTitle}>
            <h4>COFFEE</h4>
          </div>
          <div>
            <table>
              <tr>
                <th></th>
                <th>MOLTO</th>
                <th>GRANDE</th>
              </tr>
              <tr>
                <td>DRIP COFFEE</td>
                <td>$1.95</td>
                <td>$2.35</td>
              </tr>
              <tr>
                <td>LATTE</td>
                <td>$3.25</td>
                <td>$3.75</td>
              </tr>
              <tr>
                <td>CAPPUCINO</td>
                <td>$3.25</td>
                <td>$3.75</td>
              </tr>
              <tr>
                <td>ESPRESSO</td>
                <td>$2.25</td>
                <td>$2.75</td>
              </tr>
              <tr>
                <td>AMERICANO</td>
                <td>$2.50</td>
                <td>$2.95</td>
              </tr>
              <tr>
                <td>HOT CHOCOLATE</td>
                <td></td>
                <td>$2.95</td>
              </tr>
            </table>
          </div>
          <div className={menuStyle.gridDouble}>
            <div className={menuStyle.foodItem}>
              <h4>FLAVOR SHOT</h4>
              <p>VANILLA</p>
              <p>MOCHA</p>
              <p>CARAMEL</p>
              <p>SEASONAL</p>
            </div>
            <div className={menuStyle.foodItem}>
              <h4>EXTRA SHOT</h4>
              <p>SUBSTITUTE OAT MILK FOR FREE</p>
            </div>
          </div>
          <div className={menuStyle.specialty}>
            <div className={menuStyle.menuTitle}>
              <h4>SPECIALTY TEAS</h4>
            </div>
            <div className={menuStyle.gridQuad}>
              <p>SWEET ORANGE</p>
              <p>ZEN</p>
              <p>BREAKFAST</p>
              <p>PASSION RASPBERRY</p>
            </div>
            <div className={menuStyle.gridTriple}>
              <p>EARLY GREY</p>
              <p>PEACH & PASSION</p>
              <p>CHAI</p>
            </div>
          </div>
          <div className={menuStyle.gridDrinks}>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinks}>
                <h4>SMOOTHIES</h4>
                <strong>MOLTO: 4.00 | GRANDE: 4.50</strong>
                <p>MANGO</p>
                <p>STRAWBERRY</p>
                <p>TROPICAL</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinks}>
                <h4>BOTTLE DRINKS</h4>
                <p>SODA - $1.75 | WATER - $1.75</p>
                <p>SPARKLING WATER - $2.75</p>
                <p>COCONUT WATER - $2.75</p>
                <p>ENERGY DRINKS - $3.50</p>
                <p>OTHER BOTTLED DRINKS - $2.25</p>
              </div>
            </div>
            <div className={menuStyle.foodItem}>
              <div className={menuStyle.drinks}>
                <h4>FRAPPES</h4>
                <strong>MOLTO: 4.00 | GRANDE: 4.50</strong>
                <p>MOCHA</p>
                <p>CARAMEL</p>
                <p>VANILLA</p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  )
}

export default MenuPage
